import { useEffect } from 'react';

const Timeout = (logoutCallback, timeoutDuration) => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            logoutCallback();
        }, timeoutDuration);

        return () => clearTimeout(timeout);
    }, [logoutCallback, timeoutDuration]);
};

export default Timeout;
